import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LenisProvider from "@/components/LenisProvider";
import Home from "@/pages/Home";
import WhatWeDo from "@/pages/WhatWeDo";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Press from "@/pages/Press";
import Admin from "@/pages/Admin";

export default function App() {
  return (
    <div className="App">
      <LenisProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/what-we-do" element={<WhatWeDo />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/press" element={<Press />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              borderRadius: 0,
              background: "#0A0A0A",
              color: "#F3F3F1",
              border: "1px solid #F3F3F1",
              fontFamily: "'IBM Plex Mono', ui-monospace, monospace",
              fontSize: "11px",
              letterSpacing: "0.08em",
              textTransform: "uppercase",
            },
          }}
        />
      </LenisProvider>
    </div>
  );
}
